import { FeatureFlags } from "./FeatureFlags";
import { loadFlags } from "./loadFlags";

export const isFlagEnabled = (flag:FeatureFlags) => {
	return loadFlags().includes(flag);
};